module.exports = __webpack_public_path__ + "static/img/profile.ec819310.jpg";